import { CustomerLead } from '../../../core/domain/customerLead.model'
import { OfferData } from '../../../core/domain/offerData.model'
import AgentService from '../../../core/services/agent.service'
import CustomerService from '../../../core/services/customer.service'
import OfferService from '../../../core/services/offer.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { redirectionProvider } from '../CalculatorRedirection.provider'
import {
  ContactDataInfoValues,
  ContactDataSection,
  View,
} from './ContactData.view'
import { AdobeEventManager } from '../../_utils/adobeAnalytics';

export class ContactDataPresenter implements LifecyclePresenter<View> {
  private view!: ContactDataSection
  private stepPageName: string = 'contact-data'
  private stepPageNumber: number = 6
  private offer: OfferData
  private customer: CustomerLead

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step6-contactData'
    AdobeEventManager.track('calc_step')

    await this.getOfferDocument()

    this.view.setInitialValues(
      {
        company: this.customer.company,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        phone: this.customer.phone,
        email: this.customer.email,
        acceptedPrivacyPolicy: this.customer.acceptedPrivacyPolicy,
      },
      this.offer.progressMask[6] === '1',
    )
  }

  getOfferDocument = async () => {
    try {
      this.offer = await OfferService.getOfferData()
      this.customer = await CustomerService.getCustomer()
    } catch (error) {
      console.log(error)
    }
  }

  onContinue = async (formValues: ContactDataInfoValues) => {
    this.manageLastVisitedStep(this.stepPageNumber)

    const customer = this.setFormValues(formValues)

    CustomerService.saveCustomer(customer).then(() =>
      OfferService.saveOfferData(this.offer).then(() => this.goToNextStep()),
    )
  }

  setFormValues = (formValues: ContactDataInfoValues) => {
    return Object.assign(this.customer, {
      ...formValues,
      acceptedPrivacyPolicy: AgentService.isAgentOrBroker()
        ? true
        : formValues.acceptedPrivacyPolicy,
    })
  }

  goToNextStep = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToFollowingStep(
        this.stepPageName,
        this.offer,
      ),
    )
  }

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName, this.offer),
    )
  }

  manageLastVisitedStep = (currentStep: number) => {
    let progress = this.offer.progressMask
    this.offer.progressMask =
      progress.substr(0, currentStep - 1) + '1' + progress.substr(currentStep)
  }
}
